"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RouteTabItem_1 = require("./RouteTabItem");
exports.default = RouteTabItem_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RouteTabItem/index.js
// module id = 1272
// module chunks = 8